/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./lucky.vue?vue&type=template&id=e569b9f6&scoped=true"
import script from "./lucky.vue?vue&type=script&lang=js"
export * from "./lucky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e569b9f6",
  null
  
)

export default component.exports